module.exports = __webpack_public_path__ + "img/pickupdumping_parked.2f2a2a76.svg";